// extracted by mini-css-extract-plugin
module.exports = {"root":"language-list_root__Q502d","button":"language-list_button__YTJEw"};